export const GAME_FAV = "GAME_FAV";
export const UPDATE_GAME_FAV = "UPDATE_GAME_FAV";